import { render, staticRenderFns } from "./InformationPanelMain.vue?vue&type=template&id=385ee2cc&scoped=true&lang=pug&"
import script from "./InformationPanelMain.vue?vue&type=script&lang=ts&"
export * from "./InformationPanelMain.vue?vue&type=script&lang=ts&"
import style0 from "./InformationPanelMain.vue?vue&type=style&index=0&id=385ee2cc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385ee2cc",
  null
  
)

export default component.exports